import { commonParams } from '@/config/common'
import { ExceptionCodes } from '@/config/exception';
import axios from 'axios'
import { Message } from 'element-ui';
import Qs from 'qs';
import { CookieInfo, delCookie } from './cookie';
import { HttpException } from './exception/http-exception';
import { Login } from '@/models/login';

// 当我们把此配置项设置成默认配置项并且设置成true的时候，axios就可以设置cookies了。
axios.defaults.withCredentials = true

export function addNoAuthHeaders(headers, cipher = "P96D0A7D0M8C3R2D0M1") {
    const CryptoJS = require("@/lib/util/crypto-js").CryptoJS;

    var random = require("@/lib/util/random.js").randomString
    const unionId = random(10);
    const nonce = random(16);
    const timestamp = new Date().getTime();
    // 计算 token。
    const token_string = nonce + timestamp + unionId + cipher;
    const token = CryptoJS.SHA1(token_string).toString().toUpperCase();
    // 计算 签名（signature）
    const signature_string = nonce + timestamp + token + unionId + cipher;
    const signature = CryptoJS.SHA1(signature_string).toString().toUpperCase();

    return Object.assign({}, headers, {
        unionId,
        nonce,
        timestamp,
        signature
    })
}

// Api request
export function requestApi(endpoint, method, headers, params, throwError = false) {
    method = method.toLowerCase()

    // noauth鉴权
    var reg = /.*\/noauth\/.*/
    if (reg.test(endpoint)) headers = addNoAuthHeaders(headers)

    var options = {
        url: commonParams.PAAS_URL + endpoint,
        method: method,
        headers: headers
    }

    switch (method) {
        case 'get':
            options['params'] = params
            break
        case 'post':
            if (!options.headers.hasOwnProperty('Content-Type')) {
                options.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            }
            if (options.headers['Content-Type'] == 'application/json') {
                options['data'] = JSON.stringify(params)
            }
            else {
                options['data'] = Qs.stringify(params, { indices: false })
            }
            break
        case 'put':
            if (!options.headers.hasOwnProperty('Content-Type')) {
                options.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            }
            if (options.headers['Content-Type'] == 'application/json') {
                options['data'] = JSON.stringify(params)
            }
            else {
                options['data'] = Qs.stringify(params, { indices: false })
            }
            break
        default:
            break
    }
    let errFromBackground = false

    return axios(options).then((res) => {
            if (res.data && res.data.success) {
                return Promise.resolve(res.data)
            }else{
                // 判断是否登录
                if (res.data.code === '99') {
                    delCookie(CookieInfo.LOGIN_USER_INFO)
                    if (_filterLogin(endpoint)) {
                        window.location.href = `${ Login.getLoginPrefix() }#/noLogin?redirect=` +
                            encodeURIComponent(window.location.href)
                    }
                }
                if (res.data.code === '97') {
                    delCookie(CookieInfo.LOGIN_USER_INFO)
                    window.location.href = `${ Login.getLoginPrefix() }#/repeatLogin?redirect=` +
                        encodeURIComponent(window.location.href)
                }
                if (throwError) {
                    return new HttpException(res.data.code, res.data.message)
                }else{
                    errFromBackground = true
                    return Promise.reject(res)
                }
            }
        }).catch((err) => {
            if(errFromBackground){
                const response = err.data
                _showError(response.code, response.message)
                return Promise.reject(response.message)
            }
            if(typeof err === 'object' && err.response){
                const response = err.response.data
                _showError(response.code, response.message)
                return Promise.reject(response.message)
            }
            if(throwError){
                return new HttpException(-1, ExceptionCodes[-1])
            }
            _showError(-1)
            return Promise.reject(ExceptionCodes[-1])
        })
}

// JSON request
export function requestJson(endpoint){
    return axios({
        url: commonParams.CDN_URL + endpoint,
        method: 'get',
        withCredentials: false
    }).then((res) => {
        return Promise.resolve(res.data)
    }).catch((error) => {
        return false
    })
}

function _showError(error_code, serverError) {
    let message
    if (!error_code) {
        message = ExceptionCodes[9999]
    } else {
        if (ExceptionCodes[error_code] === undefined) {
            message = serverError
        } else {
            message = ExceptionCodes[error_code]
        }
    }

    Message.warning({
        type: 'warning',
        message
    })
}

function _filterLogin(endpoint) {
    const bool = 
        endpoint.substring(0, 27) !== '/survey/answer/noauth/init/' && 
        endpoint.substring(0, 19) !== '/survey/detail/get/' && 
        endpoint.substring(0, 19) !== '/survey/answer/init' && 
        endpoint.substring(0, 19) !== '/system/user/roleUp' &&
        !endpoint.includes('/order/roleUpgrade/createOrderId') &&
        !endpoint.includes('/system/user/get') &&
        !endpoint.includes('/system/user/roleUpgradeMes/get');
    return bool;
};


// WEBPACK FOOTER //
// ./src/lib/request.js